import Swal from 'sweetalert2';
import { DeviceUUID } from 'device-uuid';
import country from "./countries.json";
import _ from "lodash";
import { Repository } from './repository';
import { useState } from 'react';
import { baseURL } from './repository/Repository';
import {Box, Tooltip } from "@mui/material";
import moment from "moment";
import { useMemo } from "react";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { TextSnippetOutlined } from '@mui/icons-material';

export const USER_ROLE = {
    admin: 0,
    student: 1,
};

export const MINIMUM_PASSWORD_CHARACTERS = 7;
export const OTP_LENGTH = 6;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;
export const PHONE_REGEX = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
export const FIND_IS_NUMBER_INCLUDED_REGEX = /\d+/;
export const Find_SPECIAL_CHARACTER = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
export const IMAGE_URL = `${baseURL}storage/`;
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "hh:mm:ss A";

export const THEME_COLORS = {
  primary: "#9834F0",
  primaryLight: "#FAF5FE",
  grayLight:"#ECEEF5",
  primaryLight2:"#8080f1",
  gray: "#f2f6f8",
  grayDark: "#64748B",
  gray2: "#6B7280",
  gray3:"#4E657C",
  gray4:"#f2f6f8",
  white: "#fff",
  danger: "#d06060",
  orange:"#FF5A5F",
  inputBorderColor:"#bdbebf"
};


export const getText = (e) => e.target.value;

export const setText = (text) => {
    return {
        target: {
            value: text
        }
    }
}

export const setChecked = (value) => {
    return {
        target: {
            checked: value
        }
    }
}

export const onToast = (title, payload, showCancelButton = true) => {
    Swal.fire({
        title,
        text: payload?.message,
        icon: payload?.status_code == 1 ? 'success' : 'error',
        cancelButtonText: 'Close',
        cancelButtonColor: THEME_COLORS.primary,
        showConfirmButton: false,
        showCancelButton,
        toast: true,
        timerProgressBar: true,
        timer: 5000,
        customClass: {
            container: "sweet-alert-container",
        },    
    })
}

export const REST_PASSWORD_STATE = {
    ENTER_EMAIL: 0,
    OTP_VERIFICATION: 1,
    RESET_PASSWORD: 2
}

export const getFile = (e) => e.target.files[0];


export const generateUniqIdForDevice = async () => {
    const navigatorInfo = window.navigator;
    const screenInfo = window.screen;
    let uid = navigatorInfo.mimeTypes.length;
    uid += navigatorInfo.userAgent.replace(/\D+/g, '');
    uid += navigatorInfo.plugins.length;
    uid += screenInfo.height || '';
    uid += screenInfo.width || '';
    uid += screenInfo.pixelDepth || '';
    return uid//uuid.visitorId;
}

export const getDeviceId = async () => {
    let machineId = localStorage.getItem('DeviceId');
    if (!machineId) {
        machineId = await generateUniqIdForDevice();
        localStorage.setItem('DeviceId', machineId);
    }

    return machineId;
};


export const onGetCurrencySymble = (code) => {
    const data = _.find(country, i => _.get(i, 'currency.code', 'USD') == code);
    return _.get(data, 'currency.symbol', '$');
}

export const getSourcePath = (path) => {
    if (_.isNull(path) || path == '') {
        return path;
    }
    const repo = new Repository();
    const url = repo.IMAGE_URL;
    return `${url}${path}`
}

export const convertStringDate = (inputDateString) => {
    // Create a Date object from the input string
    const inputDate = new Date(inputDateString);

    // Get day, month, and year components
    const day = inputDate.getDate();
    const month = inputDate.getMonth() + 1; // Month is zero-based, so add 1
    const year = inputDate.getFullYear();

    // Pad day and month with leading zeros if necessary
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${year}-${formattedMonth}-${formattedDay}`;
}

export const convertStringTime = (timeString) => {
    // Parse the time string into a Date object
    const date = new Date(timeString);

    // Extract hours and minutes
    const hours24 = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const ampm = hours24 >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    const hours12 = (hours24 % 12) || 12;

    return {
        convertTime: {
            time: `${(hours12 < 10 ? '0' : '') + hours12}:${(minutes < 10 ? '0' : '') + minutes}`,
            timeExt: ampm,
        }
    }

}
const maxLength = 100;
export const makeTruncate = (text = '') => {
    if (text.length > maxLength) {
        return text.substr(0, maxLength) + '...'
    }
    return text;
}

export const usePagination = (data, itemsPerPage, search) => {
    const [currentPage, setCurrentPage] = useState(1);
    const maxPage = Math.ceil(data?.length / itemsPerPage);

    const currentData = () => {
        const begin = (currentPage - 1) * itemsPerPage;
        const end = begin + itemsPerPage;
        if (search !== "") {
            return data;

        } else {
            return data?.slice(begin, end);
        }
    }

    const next = () => {
        setCurrentPage(currentPage => Math.min(currentPage + 1, maxPage));
    }

    const prev = () => {
        setCurrentPage(currentPage => Math.max(currentPage - 1, 1));
    }

    const jump = (page) => {
        const pageNumber = Math.max(1, page);
        setCurrentPage(currentPage => Math.min(pageNumber, maxPage));
    }

    return { next, prev, jump, currentData, currentPage, maxPage };
}
export const emptyDropDown = (selectElement) => {
    var i, L = selectElement?.options?.length - 1;
    for (i = L; i >= 0; i--) {
        selectElement.remove(i);
    }
}


export const COURSE_SECTION_TYPE_ID = {
    VIDEO: 1,
    QUIZ: 2,
    DOCUMENT: 3,
};

export const COURSE_SECTION_TYPE = [
    {
        id: COURSE_SECTION_TYPE_ID.VIDEO,
        name: 'Video',
    },
    {
        id: COURSE_SECTION_TYPE_ID.QUIZ,
        name: 'Quiz',
    },
    {
        id: COURSE_SECTION_TYPE_ID.DOCUMENT,
        name: 'Document',
    },
];

export const ACTION_LABEL = {
    [COURSE_SECTION_TYPE_ID.VIDEO]: "View",
    [COURSE_SECTION_TYPE_ID.QUIZ]: "Start Quiz",
    [COURSE_SECTION_TYPE_ID.DOCUMENT]: "Read Doc",
};

export const COURSE_TYPE_LIST = [
    { id: 1, name: 'Normal Course' },
    { id: 2, name: 'Dual Course' }
];

export const getFileType = (fileName) => {
    if (!fileName || typeof fileName !== "string") {
        return "";
    }
    let splitArr = fileName.split('.');
    let fileType = splitArr[splitArr.length - 1];
    return fileType;
}

const DOCUMENT_ICON_MAP = {
  jpg: { icon: "image", color: "#9834F0" },
  jpeg: { icon: "image", color: "#9834F0" },
  png: { icon: "image", color: "#9834F0" },
  gif: { icon: "image", color: "#9834F0" },
  webp: { icon: "image", color: "#9834F0" },
  svg: { icon: "image", color: "#9834F0" },
  bmp: { icon: "image", color: "#9834F0" },
  pdf: { icon: "pdf", color: "#E04F5F" },
  doc: { icon: "doc", color: "#2196F3" },
  docx: { icon: "doc", color: "#2196F3" },
  csv: { icon: "excel", color: "#4CAF50" },
  xls: { icon: "excel", color: "#4CAF50" },
  xlsx: { icon: "excel", color: "#4CAF50" },
};

const DEFAULT_ICON = { icon: "file", color: "#9E9E9E" };

export const getDocumentIconConfig = (fileName) => {
  const ext = getFileType(fileName)?.toLowerCase();
  if (!ext) return DEFAULT_ICON;
  return DOCUMENT_ICON_MAP[ext] || DEFAULT_ICON;
};


export const CLOUD_FRONT_URL = 'https://d3oaompef0i2u8.cloudfront.net/videos/'

export const checkIsImageFile = (fileName, isFolder) => {
    if (isFolder || !fileName) return false;
    return /\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(fileName);
};

export const DOCUMENT_STATUS = {
    INACTIVE: 0,
    ACTIVE: 1,
};


export const renderTruncatedText = (text, options = {}) => {
  const { limit = 40, sx = {}, placement = "top", arrow = true } = options;
  const stringText = String(text || "");
  const isTruncated = stringText.length > limit;
  const displayedText = isTruncated 
    ? `${stringText.substring(0, limit)}...` 
    : stringText;

    return (
      <Tooltip title={stringText} placement={placement} arrow={arrow} disableHoverListener={!isTruncated}>
      <Box 
        component="span"
        sx={{ 
          cursor: isTruncated ? "pointer" : "default",
          ...sx 
        }}
      >
        {displayedText}
      </Box>
      </Tooltip>
    );
};

export const renderTableCell = (value, options = {}) => {
  const { 
    maxLength = 70, 
    isList = false, 
    rowIndex = 0, 
    placement = "top" 
  } = options;

  // Internal helper to process a single string line
  const processText = (text, limit) => {
    const stringText = String(text || "");
    const isTruncated = stringText.length > limit;
    const displayedText = isTruncated 
      ? `${stringText.substring(0, limit)}...` 
      : stringText;

    return (
      <Tooltip 
        title={stringText} 
        placement={placement} 
        arrow 
        disableHoverListener={!isTruncated}
      >
        <span style={{ cursor: isTruncated ? 'pointer' : 'default' }}>
          {displayedText}
        </span>
      </Tooltip>
    );
  };

  // If the data is an array/list of courses
  if (isList) {
    const courses = Array.isArray(value) ? value : (value ? [value] : []);
    
    if (!courses.length) return <div style={{ width:"100%", textAlign:"center", marginLeft:"-10px" }}><span>-</span></div>
        
    return (
      <ul style={{ margin: 0, paddingLeft: 16 }}>
        {courses.map((item, idx) => {
          const courseName = item.course?.name || "Unnamed Course";
          return (
            <li key={`${rowIndex}-${item.course?.id || idx}`}>
              {processText(courseName, maxLength)}
            </li>
          );
        })}
      </ul>
    );
  }

  return processText(value, maxLength);
};

export const prepareDirectoryData = (directories = [], items = [], nameMapping = {}) => {
  const normalizedFolders = directories.map((item) => ({
    ...item,
    name: item.directory_name || item.name,
    is_directory: item.quiz_id === null ? IS_DIRECTORY_FOLDER : 0,
  }));

  const normalizedItems = items.map((item) => ({
    ...item,
    is_directory: 0,
  }));

  return [...normalizedFolders, ...normalizedItems]
    .map((item) => ({
      ...item,
      createdDate: moment(item.created_at).format("DD/MM/YYYY HH:mm:ss"),
    }))
    .sort((a, b) => Number(b.is_directory) - Number(a.is_directory));
};

export const IS_DIRECTORY_FOLDER = 1;

export const isFolder = (doc) => Number(doc?.is_directory) === IS_DIRECTORY_FOLDER;

export const normalizeQuizDirectoryData = (directories = [], quizzes = []) => {
  const actualFolders = [];
  const nestedQuizzes = [];

  (directories || []).forEach((item) => {
    // If quiz_name or quiz_id exists, treat as Quiz; otherwise treat as Folder
    if (item?.quiz_name || item?.quiz_id) {
      nestedQuizzes.push({
        ...item,
        id: item.id,
        quiz_id: item.quiz_id,
        name: item.quiz_name || item.name || "",
        is_directory: 0,
        is_unassigned: item.is_unassigned ?? 0,
        is_assign: item.is_assign ?? 0,
      });
    } else {
      actualFolders.push({
        ...item,
        id: item.id,
        name: item.directory_name || item.name || "",
        is_directory: 1,
      });
    }
  });

  const formattedQuizzes = (quizzes || []).map((quiz) => ({
    ...quiz,
    id: quiz.id || quiz.quiz_id,
    name: quiz.quiz_name || quiz.name || "",
    is_directory: 0,
    is_unassigned: quiz.is_unassigned ?? 1,
  }));

  return [...actualFolders, ...nestedQuizzes, ...formattedQuizzes];
};

export const navigateToQuizWithBreadcrumb = (navigate, location) => {
  let currentTrail = location?.state?.breadcrumbTrail;
  let returnPath = location?.state?.quizData?.returnPath
  const courseId = location?.state?.quizData?.course_id
  
  if (!currentTrail?.length) {
    try {
      if(returnPath === "/course-details"){
        navigate("/course-details", {
          state: {
            course_id: courseId,
            is_registered: true,
          },
        });
        return
      } else {
        const saved =
        sessionStorage.getItem("quiz_breadcrumb") ||
        sessionStorage.getItem("std_quiz_breadcrumb_trail");
        currentTrail = saved ? JSON.parse(saved) : [{ id: null, name: "Quiz" }];
      }
    } catch (e) {
      currentTrail = [{ id: null, name: "Quiz" }];
    }
  }

  let currentCourse = location?.state?.selectedCourse;
  if (!currentCourse) {
    try {
      const savedCourse =
        sessionStorage.getItem("quiz_course") ||
        sessionStorage.getItem("std_quiz_selected_course");
      currentCourse = savedCourse ? JSON.parse(savedCourse) : null;
    } catch (e) {
      currentCourse = null;
    }
  }

  

  navigate("/quiz", {
    state: {
      breadcrumbTrail: currentTrail,
      selectedCourse: currentCourse,
    },
  });
};

export const buildThumbnailUrl = (baseUrl, relativePath) => {
  if (!relativePath) return null;

  if (relativePath instanceof File || relativePath instanceof Blob) {
    return relativePath;
  }

  if (/^(data:|https?:\/\/)/i.test(relativePath)) {
    return relativePath.replace(/^http:\/\//i, "https://");
  }

  if (!baseUrl) return relativePath;

  // Format base URL
  const secureBase = baseUrl.startsWith("http")
    ? baseUrl.replace(/^http:\/\//i, "https://")
    : `https://${baseUrl.replace(/^\/+/, "")}`;

  const cleanBase = secureBase.replace(/\/+$/, "");
  const cleanPath = relativePath.replace(/^\/+/, "");

  return `${cleanBase}/${cleanPath}`;
};

export const useActiveQuizData = (reduxQuizData, locationQuizData, locationState = {}) => {
  const baseUrl = useMemo(() => {
    return (
      locationState?.baseUrl ||
      reduxQuizData?.base_url ||
      reduxQuizData?.data?.base_url ||
      locationQuizData?.base_url ||
      reduxQuizData?.data?.data?.base_url ||
      ""
    );
  }, [locationState?.baseUrl, reduxQuizData, locationQuizData]);

  const rawQuizItem = useMemo(() => {
    const quiz = reduxQuizData?.data?.quiz || reduxQuizData?.quiz;
    if (Array.isArray(quiz)) return quiz[0];
    return quiz || reduxQuizData || locationQuizData;
  }, [reduxQuizData, locationQuizData]);

  const activeQuizData = useMemo(() => {
    if (!rawQuizItem) return null;

    const quizList = Array.isArray(reduxQuizData?.data?.quiz)
      ? reduxQuizData.data.quiz
      : Array.isArray(reduxQuizData?.quiz)
        ? reduxQuizData.quiz
        : [];

    const courseIds = Array.isArray(rawQuizItem?.courses)
      ? rawQuizItem.courses.map((course) => course?.id).filter(Boolean)
      : [];
    const directoryCourseIds = Array.isArray(rawQuizItem?.quiz_directories)
      ? rawQuizItem.quiz_directories.map((directory) => directory?.course_id).filter(Boolean)
      : [];

    const selectedCourses = Array.from(
      new Set(
        (directoryCourseIds.length
          ? directoryCourseIds
          : courseIds.length
          ? courseIds
          : quizList.map((item) => item?.quiz_courses_course_id))
          .filter(Boolean)
      )
    );

    const allDirectories = Array.isArray(rawQuizItem?.quiz_directories)
      ? rawQuizItem.quiz_directories
      : quizList.reduce((acc, item) => {
      if (Array.isArray(item?.directories)) {
        item.directories.forEach((dir) => {
          if (!acc.some((existing) => existing.id === dir.id)) {
            acc.push(dir);
          }
        });
      }
      return acc;
    }, []);

    const fullThumbnail = buildThumbnailUrl(
      baseUrl,
      rawQuizItem?.quiz_thumbnail
    );

    return {
      ...rawQuizItem,
      quiz_thumbnail_url: fullThumbnail,
      quiz_thumbnail: fullThumbnail,
      thumbnail: fullThumbnail,
      preview: fullThumbnail,
      selectedCourses: selectedCourses.length
        ? selectedCourses
        : rawQuizItem?.quiz_courses_course_id
        ? [rawQuizItem.quiz_courses_course_id]
        : [],
      directories: allDirectories.length
        ? allDirectories
        : rawQuizItem?.directories || rawQuizItem?.quiz_directories || [],
    };
  }, [rawQuizItem, baseUrl, reduxQuizData]);

  return { baseUrl, rawQuizItem, activeQuizData };
};

export const planFields = {
   planName: "",
   duration: "",
   price: "",
   planExpiryDate: "",
   batchYear: "",
   batchMonth: "",
}


export const PLAN_FIELD_MAP = {
  planName: 'plan_name',
  duration: 'duration_weeks',
  price: 'price',
  planExpiryDate: 'expires_at',
  batchMonth: 'batch_month',
  batchYear: 'batch_year',
};

export const PLAN_FIELD_MAP_WITH_ID = {
  ...PLAN_FIELD_MAP,
  id: 'id',
};



export const safeBuildThumbnailUrl = (baseUrl, path) => {
  if (!path) return "";
  if (path.startsWith("https://")) {
    return path;
  }
  
  const cleanBase = (baseUrl || "").replace(/\/+$/, "");
  const cleanPath = path.replace(/^\/+/, "");

  return cleanBase ? `${cleanBase}/${cleanPath}` : cleanPath;
};

// Extract base URL from localStorage
export const getBaseUrl = () => {
  try {
    const rawConfig = localStorage.getItem("configuration");
    if (!rawConfig) return "";
    const parsedConfig = JSON.parse(rawConfig);
    return parsedConfig?.base_url || parsedConfig?.data?.base_url || "";
  } catch (error) {
    console.error("Error parsing base_url from localStorage:", error);
    return "";
  }
};

export const getLocalStorageThumbnail = (keyName) => {
  try {
    const rawConfig = localStorage.getItem("configuration");
    if (!rawConfig) return "";

    const parsedConfig = JSON.parse(rawConfig);
    const configurations =
      parsedConfig?.configurations || parsedConfig?.data?.configurations || [];

    const configItem = configurations.find(
      (item) => item.key === keyName && Number(item.is_active) === 1
    );

    return configItem?.value || "";
  } catch (error) {
    console.error("Error reading configuration from localStorage:", error);
    return "";
  }
};

export const getThumbnailSrc = (apiThumbnail, fallbackKey) => {
  const baseUrl = getBaseUrl();

  if (apiThumbnail) {
    return safeBuildThumbnailUrl(baseUrl, apiThumbnail);
  }

  const localStoragePath = getLocalStorageThumbnail(fallbackKey);
  if (localStoragePath) {
    return safeBuildThumbnailUrl(baseUrl, localStoragePath);
  }

  return "";
};

export const resolveDocumentThumbnailSrc = (apiThumbnail = null, docMeta = {}) => {
  const { isFolder = false, isImage = false } = docMeta || {};

  if (apiThumbnail) {
    return getThumbnailSrc(apiThumbnail, isFolder ? 'folder_thumbnail' : isImage ? 'image_thumbnail' : 'file_thumbnail');
  }

  const fallbackKey = isFolder ? 'folder_thumbnail' : isImage ? 'image_thumbnail' : 'file_thumbnail';
  return getThumbnailSrc(null, fallbackKey) || "";
};

export const THUMBNAIL_KEY_MAP = {
  quiz: "quiz_thumbnail",
  file: "file_thumbnail",
  folder: "folder_thumbnail",
  image: "image_thumbnail",
  video: "video_thumbnail",
  text: "markup_percentage"
};

export const createInitialThumbnailState = () =>
  Object.keys(THUMBNAIL_KEY_MAP).reduce((acc, key) => {
    acc[key] = { url: null, id: null };
    return acc;
  }, {});

  export const transformConfigurationResponse = (apiResponse) => {
  const thumbnailState = createInitialThumbnailState();
  const configurations = apiResponse?.data?.configurations || [];
  const baseUrl = apiResponse?.data?.base_url || "";

  configurations.forEach((item) => {
    const typeKey = Object.keys(THUMBNAIL_KEY_MAP).find(
      (key) => THUMBNAIL_KEY_MAP[key] === item.key
    );
    if ( typeKey && typeKey !== "text" && thumbnailState[typeKey]) {
      thumbnailState[typeKey] = {
        url: buildThumbnailUrl(baseUrl, item.value),
        id: item.id,
      };
    }
    if(typeKey === "text"){
     thumbnailState[typeKey] = {
        value: item.value,
        id: item.id,
      };
    }
  });

  return thumbnailState;
};

export const buildThumbnailFormData = (typeKey, file) => {
  const payloadKey = THUMBNAIL_KEY_MAP[typeKey] || `${typeKey}_thumbnail`;
  const formData = new FormData();
  formData.append(payloadKey, file);
  return formData;
};

export const getThumbnailPayloadKey = (typeKey) => {
  return THUMBNAIL_KEY_MAP[typeKey] || `${typeKey}_thumbnail`;
};

export const CONTENT_TYPES = [
  { id: "quiz", label: "Quiz", icon: QuizOutlinedIcon, color: "#9834F0" },
  { id: "file", label: "File", icon: InsertDriveFileOutlinedIcon, color: "#2196F3" },
  { id: "folder", label: "Folder", icon: FolderOutlinedIcon, color: "#FF9800" },
  { id: "image", label: "Image", icon: ImageOutlinedIcon, color: "#4CAF50" },
  { id: "video", label: "Video", icon: PlayCircleOutlineIcon, color: "#E91E63" },
  { id: "text", label: "Text", icon: TextSnippetOutlined, color: "#ff7961" },
];

export const syncSessionState = (locationState, entityType = "quiz") => {
  if (!locationState) return;

  const { breadcrumbTrail, selectedCourse } = locationState;

  if (breadcrumbTrail?.length) {
    sessionStorage.setItem(`${entityType}_breadcrumb`, JSON.stringify(breadcrumbTrail));
    sessionStorage.setItem(`std_${entityType}_breadcrumb_trail`, JSON.stringify(breadcrumbTrail));
  }

  if (selectedCourse !== undefined && selectedCourse !== null) {
    sessionStorage.setItem(`${entityType}_course`, JSON.stringify(selectedCourse));
    sessionStorage.setItem(`std_${entityType}_selected_course`, JSON.stringify(selectedCourse));
  }
};

// Safe session reader for fallback navigation
export const getStoredBreadcrumb = (entityType = "quiz") => {
  try {
    const data = sessionStorage.getItem(`${entityType}_breadcrumb`);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error(`Error reading ${entityType}_breadcrumb`, e);
    return null;
  }
};

export const DEFAULT_CURRENCY = "USD"
export const APPROXIMATESIGN = "~"

export const ASSOCIATION_CATEGORY = {
  CHILDREN: "children",
  IS_ASSOCIATED: "is_associated",
  ASSOCIATE_FOLDERS: "associate_folders",
  COURSE_CONTENT: "course_content",
};

export const ASSOCIATION_ACTION = {
  DELETE: "delete",
  EDIT: "edit",
};

export const PLAN_STATUS = {
  EXPIRED:"EXPIRED"
}


export const promoCodeTypes =  {
  PERCENTAGE: 1, 
  AMOUNT: 2
}

export const EXISTING_COURSE_STATUS = {
  PAID : 0,
  FREE: 1
}

export const REGISTRED_COURSE_STATUS = {
  REGISTRED : 1, 
  UNREGISTRED : 0
}

export const WALKTHROUGH_VIDEO_STATUS = {
  SEEN : true, 
  UNSEEN : false
}

export const WEBINAR_STATUS = {
  ON : true, 
  OFF : false
}

export const MARK_AS_COMPLETE = {
  ON : 1, 
  OFF : 0
}


